import { api } from './api';

export const originalPromptsApi = {
  // オリジナルプロンプト一覧を取得
  async getOriginalPrompts(projectId) {
    const response = await api.get(`/projects/${projectId}/original-prompts`);
    return response.data;
  },

  // 特定のオリジナルプロンプトを取得
  async getOriginalPrompt(projectId, promptId) {
    const response = await api.get(`/projects/${projectId}/original-prompts/${promptId}`);
    return response.data;
  },

  // オリジナルプロンプトを作成
  async createOriginalPrompt(projectId, promptData) {
    const response = await api.post(`/projects/${projectId}/original-prompts`, promptData);
    return response.data;
  },

  // オリジナルプロンプトを更新
  async updateOriginalPrompt(projectId, promptId, promptData) {
    const response = await api.put(`/projects/${projectId}/original-prompts/${promptId}`, promptData);
    return response.data;
  },

  // オリジナルプロンプトを削除
  async deleteOriginalPrompt(projectId, promptId) {
    const response = await api.delete(`/projects/${projectId}/original-prompts/${promptId}`);
    return response.data;
  },
};